module.exports = __webpack_public_path__ + "media/landing_page/why-shoppers-pp-0-00598761.jpg";